import React from 'react';
var VeltCommentsMinimap = function (props) {
    var position = props.position, targetScrollableElementId = props.targetScrollableElementId;
    return (React.createElement("velt-comments-minimap", { position: position, "target-scrollable-element-id": targetScrollableElementId }));
};
export default VeltCommentsMinimap;
